<template>
<div class="headlinehome">
    <b-row>
        <b-col v-if="langfrench">
            <h4 class="clienttxt">Quelque institution, organisation, société ou entreprise qui ont déjà travaillé avec Graphikodesign </h4>
        </b-col>
        <b-col v-else>
            <h4 class="clienttxt">Some companies that have already worked with Graphikodesign</h4>
        </b-col>
    </b-row>
    <br>
    <b-row>
        <b-col v-for="(clientlogos, index) in clientLogo " xl="2" lg="3" md="4" sm="6" xs="12" ml-md-auto class="d-flex justify-content-center mb-3">
        
                <div class="piclogoclienthome">
                    <b-img :src="wurl + '/imgsrv/' + clientlogos.logopic" alt="Responsive image"></b-img>
                </div>
     
        </b-col>
    </b-row>
</div>
</template>

<script>
import axios from "axios"
//bus for handling component interconnection
import {
    EventBus
} from "@/event-bus.js";
import {
    globalSiteSetting
} from "../main.ts";

export default {

    data() {
        return {
            wurl: globalSiteSetting.siteurl,
            clientLogo: [],
            langfrench:true
        }
    },
    methods: {
        retrieveData() {
            var app = this;
            var weburl = this.wurl;

            axios
                .get(weburl + "/api.data.php?req=dynamicdata&p=clients&auth=razafy", {
                    crossDomain: true,
                })
                .then((response) => {
                    //put result to available array
                    this.clientLogo = this.clientLogo.concat(response.data);
                });
        },
       togglefrenchlangage() {
            this.langfrench = true
            //console.log('lang is now french')
        },
        toggleenglishlangage() {
            this.langfrench = false
            //console.log('lang is now english')
        }
    },
    mounted() {
        this.retrieveData()
           //listen to langage change
        EventBus.$on('togglelangtofrench', () => {
            this.togglefrenchlangage()
        })
        EventBus.$on('togglelangtoenglish', () => {
            this.toggleenglishlangage()
        })
    }
}
</script>
